import script from "./miniAppShare.vue?vue&type=script&lang=ts&setup=true"
export * from "./miniAppShare.vue?vue&type=script&lang=ts&setup=true"

import "./miniAppShare.vue?vue&type=style&index=0&id=d897fbc2&scoped=true&lang=css"

import exportComponent from "E:\\vs\\integrate-system\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d897fbc2"]])

export default __exports__